import { FaArrowLeft } from 'react-icons/fa';

function BackToLogin({ message, url }: { message: string, url: string }) {

    message = message.replace(/&laquo|;|&raquo/g, '');

    return (
        <>
            <button
                type="button"
                onClick={() => window.history.back()}
                className='d-flex justify-content-start align-items-center mt-4 mb-3 btn btn-link p-0'
                id="backToLogin">
                <FaArrowLeft style={{ marginRight: '0.4em' }} />
                <span dangerouslySetInnerHTML={{
                    "__html": message,
                }} />
            </button>
        </>
    )
}

export default BackToLogin;
